import { Component, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConnectionService } from '../../services/connection.service';
import { MediaService } from '../../services/media.service';
import { getEditorDefaults, PinturaDefaultImageWriterResult, PinturaNode } from '@pqina/pintura';
import { Media } from '@contracts/interfaces/media.interfaces'
import { HttpEventType } from '@angular/common/http';

export interface DialogData {
    view: boolean;
    media: Media;
    saveAsFileName: string;
    saveAsFolder: string;
    index: number;
    list: Media[];
}

@Component({
  selector: 'app-dialog-image',
  templateUrl: 'image.dialog.html',
  styleUrls: ['./image.dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImageDialogComponent {
  @ViewChild('editor') editorRef?: any;
  
  public checked: boolean = false;

  public view: boolean = false;

  public media: Media = null;
  public filename: string = "";
  public imageSrc: string = "";

  public saveAsFilename: string = "";
  public saveAsFolder: string = "";

  public showUploadField = false;

  public options: any;

  public list: Media[] = [];
  public index: number = null;

  private closeOnSave = true;

  willRenderToolbar = (
    toolbar: PinturaNode[],
    env: any,
    redraw: () => void
  ): PinturaNode[] => {

    // toolbar[2][3].unshift(deleteNode);
    // toolbar[2][3].unshift(downloadNode);
    //toolbar[2][3].splice(0, 1);
    //toolbar[2][3][3][2]["label"] = "Save"
    //console.log(toolbar)

    return [];
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ImageDialogComponent>,
    public connectionService: ConnectionService,
    public mediaService: MediaService
    ) { }

  ngOnInit() {

    if (this.data.index != undefined) {
      this.list = this.data.list;
    }

    if (this.data.index != undefined) {
      this.index = this.data.index;
    }

    this.load(this.data.media);
  }

  load(media: Media) {

    let targetSize = undefined;
    // if (this.data.image.size != undefined) {
    //   targetSize = this.data.image.size;
    // }

    this.options = getEditorDefaults({
      // This will set a square crop aspect ratio
      //imageCropAspectRatio: 1,
      imageCropLimitToImage: false,
      imageBackgroundColor: [1, 1, 1],
      
      imageWriter: {
        targetSize: targetSize
      },
    });

    this.mediaService.check(media).subscribe((r: any) => {
      console.log(media)
      if (r) {
        this.filename = media.filename;
        this.imageSrc = this.connectionService.address + "/" + media.path.replace(/^\/|\/$/g, '') + "/" + media.filename;
        this.view = this.data.view;
        this.checked = true;
        this.media = media;
        console.log(this.imageSrc)
      } else {
        this.media = null;
        console.log("Image does not exist?");
        this.dialogRef.close({type: "error", image: this.filename});
      }
    });
  }

  save() {
    this.uploadEdittedImage = (imageWriterResult: PinturaDefaultImageWriterResult) => {
      return this.mediaService.upload(imageWriterResult.dest, this.media, true).subscribe((reply) => {
        if (reply.type === HttpEventType.Response) {
          this.dialogRef.close({type: "saved", image: this.media});
        }      
      });
    }

    this.editorRef.editor.processImage().then((imageWriterResult: PinturaDefaultImageWriterResult) => {})
  }

  uploadEdittedImage(imageWriterResult: PinturaDefaultImageWriterResult) {}

  getImageUrl(image: string) {
    return "url('" + image + "?height=1200')";
  }

  next() {

    if (!this.view) {
      this.uploadEdittedImage = (imageWriterResult: PinturaDefaultImageWriterResult) => {
        return this.mediaService.upload(imageWriterResult.dest, this.media, true).subscribe((reply) => {
          if (reply.type === HttpEventType.Response) {
            this.index++;
            if (this.index > this.list.length) {
              console.log("HIT");
              this.dialogRef.close();
            } else {
              this.load(this.list[this.index]);
            }
          }    
        });
      }

      this.editorRef.editor.processImage().then((imageWriterResult: PinturaDefaultImageWriterResult) => {
        this.index++;
        if (this.index > this.list.length - 1) {
          this.dialogRef.close();
        } else {
          this.load(this.list[this.index]);
        }
      });
    } else {
      this.index++;
      if (this.index > this.list.length - 1) {
        this.dialogRef.close();
      } else {
        this.load(this.list[this.index]);
      }
    }
  }

  previous() {
    if (!this.view) {
      this.uploadEdittedImage = (imageWriterResult: PinturaDefaultImageWriterResult) => {
        return this.mediaService.upload(imageWriterResult.dest, this.media, true).subscribe((reply) => {
          if (reply.type === HttpEventType.Response) {
            console.log(this.index)
            if (this.index < 0) {
              this.dialogRef.close();
            } else {
              this.load(this.list[this.index]);
            }
          }    
        });
      }

      this.editorRef.editor.processImage().then((imageWriterResult: PinturaDefaultImageWriterResult) => {
        this.index--;
        if (this.index < 0) {
          this.dialogRef.close();
        } else {
          this.load(this.list[this.index]);
        }
      });
    } else {
      this.index--;
      if (this.index < 0) {
        this.dialogRef.close();
      } else {
        this.load(this.list[this.index]);
      }
    }
  }

  edit() {
    this.view = false;
  }

  delete() {
    this.mediaService.delete(this.media).subscribe(()=> {
      this.dialogRef.close({type: "deleted"})
    });
  }

  close() {
    this.dialogRef.close({type: ""})
  }

  check() {
    console.log(this.media)
  }
}


const downloadFile = (file: File): void => {
  // Create a hidden link and set the URL using createObjectURL
  const link = document.createElement('a');
  link.style.display = 'none';
  link.href = URL.createObjectURL(file);
  link.download = file.name;

  // We need to add the link to the DOM for "click()" to work
  document.body.appendChild(link);
  link.click();

  // To make this work on Firefox we need to wait a short moment before clean up
  setTimeout(() => {
      URL.revokeObjectURL(link.href);
      link.parentNode.removeChild(link);
  }, 0);
};